import {AppBar, Box, Toolbar} from "@mui/material";
import React from "react";
import EnvironmentFlag from '../../components/utils/EnvironmentFlag';
import styled from "@emotion/styled";
import {Link} from "react-router-dom";
import {DrawerType} from "../../types/types";
import RightDrawersHeader from "../../components/utils/RightDrawersHeader";

export interface TopBarProps {
    openDrawer: (type: DrawerType) => void;
    drawerType: DrawerType | undefined;
}

const TopBar = ({openDrawer, drawerType} : TopBarProps) => (
    <AppBar position="fixed" sx={{ bgcolor: "#e9edf3", height: 80 }}>
        <EnvironmentFlag />
        <Toolbar sx={{ height: 80 }} style={{paddingRight: '0px'}}>
            <TopBarContainer to="/">
                <Logo src="audi-logo.png" />
                <Title>Workbench</Title>
            </TopBarContainer>
            <Box sx={{ flexGrow: 1 }} />
            <div style={{display: 'flex', alignItems: 'right'}}>
                <RightDrawersHeader openDrawer={openDrawer} drawerType={drawerType} />
            </div>
        </Toolbar>
    </AppBar>
);

const Title = styled.div`
  display: none;
  color: black;
  font-size: 16px;
  padding-left:20px;
  @media (min-width: 600px) {
    display: block;
  }
`;

const Logo = styled.img`
  height: 25px;
  width: auto;
`;

const TopBarContainer = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  padding: 0 5px;
`;

export default TopBar;